module.exports = __webpack_public_path__ + "static/media/more_games_ms.8915353c.png";